import { useSettings } from "../hooks/useSettings";
import { useLocation, Outlet, matchPath } from "react-router-dom";

export function NavItemGuard() {
  const { settings, isLoading } = useSettings();
  const location = useLocation();

  if (isLoading) return null;

  const alwaysAllowed = [
    "/login",
    "/",
    "/community",
    "/thank-you",
    "/Terms-Of-Use",
    "/Privacy-Policy",
    "/blog/:id",
    "/propertyDetails/:id",
    "/sponsors",
    "/investments",
    "/investments/:id",
    "/free",
    "/free/:id",
  ];

  // The Team page moved from /Realtors to /Team. A nav item pointing at either path authorises
  // both, so the page resolves whether or not a community's row has been repointed — while
  // still being gated by that row's status flag, unlike the alwaysAllowed list above.
  const PATH_ALIASES = { "/Realtors": "/Team", "/Team": "/Realtors" };
  const withAliases = (path) =>
    PATH_ALIASES[path] ? [path, PATH_ALIASES[path]] : [path];

  const allowedPaths = [
    ...alwaysAllowed,
    ...(settings?.navItems || [])
      .filter((item) => item.status)
      .flatMap((item) => withAliases(item.path)),
    ...(settings?.navItems || [])
      .flatMap((item) =>
        (item.dropdownItems || [])
          .filter((d) => d.status)
          .flatMap((d) => withAliases(d.path))
      ),
  ].filter(Boolean);

  const isAllowed = allowedPaths.some(pattern =>
    matchPath({ path: pattern, end: true }, location.pathname)
  );

  if (!isAllowed) {
    return (
      <div className="grid h-screen place-content-center bg-white px-4">
        <h1 className="uppercase tracking-widest text-gray-500">
          Not found
        </h1>
      </div>
    );
  }

  return <Outlet />;
}